import React, { useEffect, useRef } from 'react';
import katex from 'katex';
import 'katex/dist/katex.min.css';

const MathRenderer = ({ htmlContent }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      // 1. Base HTML insert karein
      containerRef.current.innerHTML = htmlContent || '';

      // 2. Inline ($...$) aur Display ($$...$$) LaTeX expressions parse karke render karein
      const renderMath = (element) => {
        // Regex for $$...$$ and $...$
        const regex = /(\$\$[\s\S]+?\$\$|\$[\s\S]+?\$)/g;
        
        const walkAndRender = (node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const text = node.nodeValue;
            if (!regex.test(text)) return;

            const span = document.createElement('span');
            let lastIndex = 0;
            
            text.replace(regex, (match, math, offset) => {
              // Add plain text before math
              if (offset > lastIndex) {
                span.appendChild(document.createTextNode(text.substring(lastIndex, offset)));
              }

              const isDisplay = math.startsWith('$$');
              const latex = isDisplay ? math.slice(2, -2) : math.slice(1, -1);

              const mathSpan = document.createElement('span');
              try {
                katex.render(latex, mathSpan, {
                  displayMode: isDisplay,
                  throwOnError: false
                });
              } catch (err) {
                mathSpan.textContent = math;
              }
              span.appendChild(mathSpan);
              lastIndex = offset + match.length;
            });

            if (lastIndex < text.length) {
              span.appendChild(document.createTextNode(text.substring(lastIndex)));
            }

            node.parentNode.replaceChild(span, node);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            Array.from(node.childNodes).forEach(walkAndRender);
          }
        };

        walkAndRender(element);
      };

      renderMath(containerRef.current);
    }
  }, [htmlContent]);

  return <div ref={containerRef} className="math-content" />;
};

export default MathRenderer;